module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rate-card-search-page"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('section', {
    staticClass: "rate-card-search-panel"
  }, [_c('div', {
    staticClass: "rate-card-search-primary"
  }, [_c('v-text-field', {
    staticClass: "rate-card-search-input",
    attrs: {
      "prepend-inner-icon": "mdi-magnify",
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "label": "Search rate cards",
      "placeholder": "Name, handle, email, country or category"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "rate-card-search-submit",
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.searchFilter()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v("Search\n          ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "rate-card-filters-toggle",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.filtersExpanded = !_vm.filtersExpanded
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-tune-variant")]), _vm._v("\n            Filters\n            "), (_vm.activeFilterCount) ? _c('span', {
    staticClass: "rate-card-filter-count"
  }, [_vm._v(_vm._s(_vm.activeFilterCount))]) : _vm._e(), _vm._v(" "), _c('v-icon', {
    attrs: {
      "right": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.filtersExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "rate-card-reset-toggle",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function($event) {
        _vm.resetFilters();
        _vm.searchFilter()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-refresh")]), _vm._v("Reset\n          ")], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtersExpanded),
      expression: "filtersExpanded"
    }],
    staticClass: "rate-card-filters-accordion"
  }, [_c('div', {
    staticClass: "rate-card-advanced-filters__header"
  }, [_c('div', [_c('span', [_vm._v("Advanced filters")]), _vm._v(" "), _c('small', [_vm._v("Audience size, profile details, categories and pricing")])]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "color": "#8b92a5"
    }
  }, [_vm._v("mdi-tune-variant")])], 1), _vm._v(" "), _c('v-card-title', {
    staticClass: "rate-card-filter-bar"
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "right"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "min-width": "135px",
      "max-width": "135px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pr-4",
    attrs: {
      "label": "Star Only",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.filters.starOnly),
      callback: function($$v) {
        _vm.$set(_vm.filters, "starOnly", $$v)
      },
      expression: "filters.starOnly"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  TikTok Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.from
    },
    model: {
      value: (_vm.filters.tiktokFollowers.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.tiktokFollowers, "from", $$v)
      },
      expression: "filters.tiktokFollowers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.to
    },
    model: {
      value: (_vm.filters.tiktokFollowers.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.tiktokFollowers, "to", $$v)
      },
      expression: "filters.tiktokFollowers.to"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Empty",
      "color": "secondary",
      "value": "orange",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.isTikTokEmpty),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isTikTokEmpty", $$v)
      },
      expression: "filters.isTikTokEmpty"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchTikTokFollower()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "max-width": "165px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  IG Followers "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.from
    },
    model: {
      value: (_vm.filters.followers.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.followers, "from", $$v)
      },
      expression: "filters.followers.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-combobox', {
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.rateCardConfig.followerOptions.to
    },
    model: {
      value: (_vm.filters.followers.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.followers, "to", $$v)
      },
      expression: "filters.followers.to"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0",
    attrs: {
      "label": "Empty",
      "color": "secondary",
      "value": "orange",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.isIgEmpty),
      callback: function($$v) {
        _vm.$set(_vm.filters, "isIgEmpty", $$v)
      },
      expression: "filters.isIgEmpty"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-28px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchIGFollower()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({}, 'v-btn', attrs, false), on), [_vm._v("\n                  Rate "), _c('v-icon', {
          attrs: {
            "right": ""
          }
        }, [_vm._v("mdi-chevron-down")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Content Type\n                      "), _c('v-select', {
    staticClass: "rate-card-content-type-input",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "hide-details": "auto",
      "items": _vm.contentTypes,
      "item-text": "title",
      "return-object": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "rate-card-content-type-option",
          style: ({
            '--media-icon-color': item.iconColor || '#616161'
          })
        }, [(item.icon) ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)]
      }
    }, {
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "rate-card-content-type-option rate-card-content-type-option--selected",
          style: ({
            '--media-icon-color': item.iconColor || '#616161'
          })
        }, [(item.icon) ? _c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.icon))]) : (item.imgIcon) ? _c('img', {
          attrs: {
            "src": item.imgIcon,
            "alt": "",
            "aria-hidden": "true"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.contentType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "contentType", $$v)
      },
      expression: "filters.contentType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Currency\n                      "), _c('v-combobox', {
    staticClass: "rate-card-rate-input",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.filters.rateCurrency),
      callback: function($$v) {
        _vm.$set(_vm.filters, "rateCurrency", $$v)
      },
      expression: "filters.rateCurrency"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    staticClass: "mb-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      From\n                      "), _c('v-text-field', {
    staticClass: "rate-card-rate-input",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.from),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "from", $$v)
      },
      expression: "filters.rate.from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_vm._v("\n                      To\n                      "), _c('v-text-field', {
    staticClass: "rate-card-rate-input",
    staticStyle: {
      "max-width": "120px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "color": "secondary",
      "type": "number",
      "hide-details": "auto"
    },
    model: {
      value: (_vm.filters.rate.to),
      callback: function($$v) {
        _vm.$set(_vm.filters.rate, "to", $$v)
      },
      expression: "filters.rate.to"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticClass: "rate-card-rate-actions"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "small": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clearRateFilters()
      }
    }
  }, [_vm._v("\n                    Clear all\n                  ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.countries,
      "item-value": "value",
      "item-text": "text",
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Country"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.country),
      callback: function($$v) {
        _vm.$set(_vm.filters, "country", $$v)
      },
      expression: "filters.country"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    staticStyle: {
      "min-width": "150px",
      "max-width": "150px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "1"
    }
  }, [_c('v-menu', {
    ref: "DOBDatePicker",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "350px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Date of Birth",
            "placeholder": "Date of Birth",
            "dense": "",
            "readonly": "",
            "outlined": "",
            "clearable": "",
            "hide-details": ""
          },
          on: {
            "change": _vm.searchFilter
          },
          model: {
            value: (_vm.filters.dateOfBirth),
            callback: function($$v) {
              _vm.$set(_vm.filters, "dateOfBirth", $$v)
            },
            expression: "filters.dateOfBirth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.dateOfBirthCal),
      callback: function($$v) {
        _vm.dateOfBirthCal = $$v
      },
      expression: "dateOfBirthCal"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.filters.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dateOfBirth", $$v)
      },
      expression: "filters.dateOfBirth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelDOB()
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.categories,
      "item-value": "value",
      "item-text": "text",
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Preferred Campaigns/Genre"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.category),
      callback: function($$v) {
        _vm.$set(_vm.filters, "category", $$v)
      },
      expression: "filters.category"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.rateCardLabels,
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Main Category"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.mainCategory),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mainCategory", $$v)
      },
      expression: "filters.mainCategory"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "items": _vm.rateCardLabels,
      "clearable": "",
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Sub Category"
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.filters.subCategory),
      callback: function($$v) {
        _vm.$set(_vm.filters, "subCategory", $$v)
      },
      expression: "filters.subCategory"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 rate-card-filter-legacy-tool",
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "max-width": "300px"
    },
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 pa-0 rate-card-filter-legacy-tool",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    staticStyle: {
      "margin-left": "-25px"
    },
    attrs: {
      "bottom": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-sort")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', {
    staticStyle: {
      "max-width": "230px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Sort By\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.sortColumns
    },
    model: {
      value: (_vm.sort.column),
      callback: function($$v) {
        _vm.$set(_vm.sort, "column", $$v)
      },
      expression: "sort.column"
    }
  })], 1), _vm._v(" "), (_vm.isSortCurrency) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Currency\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.sort.currency),
      callback: function($$v) {
        _vm.$set(_vm.sort, "currency", $$v)
      },
      expression: "sort.currency"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12",
      "lg": "12"
    }
  }, [_vm._v("\n                      Type\n                      "), _c('v-select', {
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "items": _vm.sortTypes
    },
    model: {
      value: (_vm.sort.type),
      callback: function($$v) {
        _vm.$set(_vm.sort, "type", $$v)
      },
      expression: "sort.type"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "60px",
      "margin-top": "-20px"
    },
    attrs: {
      "min-height": "100px"
    }
  }, [_c('v-list-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("\n                    Apply\n                  ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pt-5 pa-0 rate-card-filter-legacy-tool",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('section', {
    staticClass: "rate-card-results-panel"
  }, [_c('div', {
    staticClass: "rate-card-results-toolbar"
  }, [_c('span', {
    staticClass: "rate-card-results-count"
  }, [_c('strong', [_vm._v(_vm._s(_vm.filteredItems.length))]), _vm._v(" rate cards")]), _vm._v(" "), _c('div', {
    staticClass: "rate-card-results-toolbar__actions"
  }, [_c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "transition": "scale-transition",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary",
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-sort")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "pa-3",
    attrs: {
      "width": "250"
    }
  }, [_c('v-select', {
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "label": "Sort by",
      "items": _vm.sortColumns
    },
    model: {
      value: (_vm.sort.column),
      callback: function($$v) {
        _vm.$set(_vm.sort, "column", $$v)
      },
      expression: "sort.column"
    }
  }), _vm._v(" "), (_vm.isSortCurrency) ? _c('v-select', {
    staticClass: "mt-3",
    attrs: {
      "outlined": "",
      "dense": "",
      "clearable": "",
      "hide-details": "auto",
      "label": "Currency",
      "items": _vm.currencyOptions
    },
    model: {
      value: (_vm.sort.currency),
      callback: function($$v) {
        _vm.$set(_vm.sort, "currency", $$v)
      },
      expression: "sort.currency"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-select', {
    staticClass: "mt-3",
    attrs: {
      "outlined": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Direction",
      "items": _vm.sortTypes
    },
    model: {
      value: (_vm.sort.type),
      callback: function($$v) {
        _vm.$set(_vm.sort, "type", $$v)
      },
      expression: "sort.type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right mt-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchFilter()
      }
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "rate-card-column-settings",
          attrs: {
            "icon": "",
            "aria-label": "Column settings"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Column settings")])])], 1)]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1 rate-card-table",
    attrs: {
      "id": "rate-card-data-table",
      "headers": _vm.computedHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")])]
      }
    }, {
      key: "item.email",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.email) + "\n          ")])]
      }
    }, {
      key: "item.dateOfBirth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_vm._v("\n            " + _vm._s(item.dateOfBirth ? _vm.utils.formatCustomDate(item.dateOfBirth, 'DD MMM, YYYY') : '') + "\n          ")])]
      }
    }, {
      key: "item.ethnicity",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.ethnicity && item.ethnicity !== 'Others' ? item.ethnicity : '') + "\n            " + _vm._s(item.otherEth ? item.otherEth : '') + "\n          ")])]
      }
    }, {
      key: "item.country",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.country) + "\n          ")])]
      }
    }, {
      key: "item.city",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.city) + "\n          ")])]
      }
    }, {
      key: "item.gender",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.gender) + "\n          ")])]
      }
    }, {
      key: "item.contactNo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.contactNo) + "\n          ")])]
      }
    }, {
      key: "item.instagramHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.instagramHandle) ? _c('social-handle', {
          attrs: {
            "isInstagram": true,
            "instagramHandle": item.instagramHandle
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.igFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.igFollowerCount)) + "\n          ")])]
      }
    }, {
      key: "item.tiktokHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.tiktokHandle) ? _c('social-handle', {
          attrs: {
            "isTikTok": true,
            "tiktokHandle": item.tiktokHandle
          }
        }) : _vm._e()], 1)]
      }
    }, {
      key: "item.tiktokFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm._f("thousandSeprator")(item.tiktokFollowerCount)) + "\n          ")])]
      }
    }, {
      key: "item.youtube",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'youtube')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'youtube'),
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-youtube")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'youtube')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.youtubeFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.youtubeFollowerCount)))])]
      }
    }, {
      key: "item.youtubeRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'youtube')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'youtube')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'youtube'))))]) : _vm._e()])]
      }
    }, {
      key: "item.facebook",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'facebook')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'facebook'),
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-facebook")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'facebook')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.linkedin",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'linkedin')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'linkedin'),
            "target": "_blank"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "#0A66C2"
          }
        }, [_vm._v("mdi-linkedin")]), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'linkedin')))], 1)]) : _vm._e()])]
      }
    }, {
      key: "item.facebookFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.facebookFollowerCount)))])]
      }
    }, {
      key: "item.facebookRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'facebook')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'facebook')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'facebook'))))]) : _vm._e()])]
      }
    }, {
      key: "item.linkedinFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.linkedinFollowerCount)))])]
      }
    }, {
      key: "item.linkedinRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'linkedin')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'linkedin')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'linkedin'))))]) : _vm._e()])]
      }
    }, {
      key: "item.twitter",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'twitter')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'twitter'),
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "mr-1",
          attrs: {
            "src": "/static/img/x-logo.svg",
            "width": "15",
            "alt": "X (Twitter)"
          }
        }), _vm._v(" " + _vm._s(_vm.getHandlePreview(item, 'twitter')))])]) : _vm._e()])]
      }
    }, {
      key: "item.twitterFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.twitterFollowerCount)))])]
      }
    }, {
      key: "item.twitterRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'twitter')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'twitter')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'twitter'))))]) : _vm._e()])]
      }
    }, {
      key: "item.twitch",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "max-width": "120px"
          }
        }, [(_vm.getPlatformUrl(item, 'twitch')) ? _c('div', [_c('a', {
          staticStyle: {
            "line-break": "anywhere"
          },
          attrs: {
            "href": _vm.getPlatformUrl(item, 'twitch'),
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.getHandlePreview(item, 'twitch')))])]) : _vm._e()])]
      }
    }, {
      key: "item.twitchFollowerCount",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.twitchFollowerCount)))])]
      }
    }, {
      key: "item.twitchRate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(_vm.getPlatformRate(item, 'twitch')) ? _c('span', [_vm._v(_vm._s(_vm.getPlatformRateCurrency(item, 'twitch')) + " " + _vm._s(_vm._f("thousandSeprator")(_vm.getPlatformRate(item, 'twitch'))))]) : _vm._e()])]
      }
    }, {
      key: "item.igStory",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igStoryCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igStory)))]) : _vm._e()])]
      }
    }, {
      key: "item.igPost",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igPostCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igPost)))]) : _vm._e()])]
      }
    }, {
      key: "item.igCarousel",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igCarouselCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igCarousel)))]) : _vm._e()])]
      }
    }, {
      key: "item.igVideo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igVideoCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igVideo)))]) : _vm._e()])]
      }
    }, {
      key: "item.igReel",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.igReelCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.igReel)))]) : _vm._e()])]
      }
    }, {
      key: "item.igRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.igRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.igRemarks))
          }
        })])], 1)]
      }
    }, {
      key: "item.tiktok",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.tiktokCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.tiktok)))]) : _vm._e()])]
      }
    }, {
      key: "item.tiktokRemarks",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left",
          staticStyle: {
            "min-width": "120px!important"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.tiktokRemarks || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.tiktokRemarks))
          }
        })])], 1)]
      }
    }, {
      key: "item.eventAppearance",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.eventAppearanceCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.eventAppearance)))]) : _vm._e()])]
      }
    }, {
      key: "item.loadingFee",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.ordinaryRates) ? _c('span', [_vm._v(_vm._s(item.ordinaryRates.loadingFeeCurrency) + " " + _vm._s(_vm._f("thousandSeprator")(item.ordinaryRates.loadingFee)))]) : _vm._e()])]
      }
    }, {
      key: "item.uploadMediaKit",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, _vm._l((item.pricingDecks), function(deck, idx) {
          return _c('v-btn', {
            key: idx,
            attrs: {
              "small": "",
              "text": "",
              "color": "secondary",
              "href": deck.url,
              "target": "_blank"
            }
          }, [_vm._v("\n              View Media\n            ")])
        }), 1)]
      }
    }, {
      key: "item.preferredCampaigns",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(!item.keywords || item.keywords.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _vm._l((item.keywords), function(keyword, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index === 0),
              expression: "index === 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "x-small": ""
            }
          }, [_vm._v(_vm._s(keyword))])
        }), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.keywords),
            expression: "item.keywords"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.keywords && item.keywords.length > 1),
                  expression: "item.keywords && item.keywords.length > 1"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('v-card-text', [_c('div', [_vm._v("Preferred Campaigns / Genre")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.keywords), function(interest, index) {
          return _c('v-chip', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index !== 0),
              expression: "index !== 0"
            }],
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(interest))])
        })], 2)], 1)], 1)], 2)]
      }
    }, {
      key: "item.labelDisplays",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(!item.mainCategories || item.mainCategories.length === 0) ? _c('v-chip', {
          staticClass: "ma-2",
          staticStyle: {
            "text-transform": "capitalize"
          },
          attrs: {
            "color": "#ffffff",
            "x-small": "",
            "text-color": "black"
          }
        }, [_vm._v(_vm._s('-'))]) : _c('v-chip', {
          staticClass: "ma-2",
          attrs: {
            "x-small": ""
          }
        }, [_vm._v(_vm._s(item.mainCategories))]), _vm._v(" "), _c('v-menu', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.mainCategories),
            expression: "item.mainCategories"
          }],
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (item.mainCategories && item.mainCategories.length > 0),
                  expression: "item.mainCategories && item.mainCategories.length > 0"
                }],
                attrs: {
                  "id": 'btnMore_' + item.id,
                  "color": "secondary",
                  "x-small": "",
                  "dark": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_vm._v("\n                  More...\n                ")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('div', [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Main Category")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-chip', {
          staticClass: "ma-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v(_vm._s(item.mainCategories))])], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Sub Category")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((item.subCategories), function(sub, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v(_vm._s(sub))])
        })], 2)], 1)])], 1)], 1)]
      }
    }, {
      key: "item.labels",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "top": "",
            "offset-x": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;
              var attrs = ref.attrs;

              return [_c('v-btn', _vm._g(_vm._b({
                staticClass: "mb-1 pa-0",
                attrs: {
                  "color": "secondary",
                  "small": "",
                  "text": ""
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                attrs: {
                  "small": ""
                }
              }, [_vm._v("edit")]), _vm._v("  Label\n                ")], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', {
          staticStyle: {
            "text-align": "left"
          },
          attrs: {
            "max-width": "300"
          }
        }, [_c('div', [_c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Main Category")]), _vm._v(" "), _c('v-divider', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }), _vm._v(" "), _c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": "",
            "required": ""
          },
          on: {
            "change": function($event) {
              return _vm.changeLabel(item)
            }
          },
          model: {
            value: (item.mainCategories),
            callback: function($$v) {
              _vm.$set(item, "mainCategories", $$v)
            },
            expression: "item.mainCategories"
          }
        }, _vm._l((_vm.rateCardLabels), function(label, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "value": label,
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        }), 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Sub Category")]), _vm._v(" "), _c('v-divider', {
          staticStyle: {
            "margin-bottom": "0"
          }
        }), _vm._v(" "), _c('v-chip-group', {
          attrs: {
            "multiple": "",
            "active-class": "primary--text",
            "column": "",
            "required": ""
          },
          on: {
            "change": function($event) {
              return _vm.changeLabel(item)
            }
          },
          model: {
            value: (item.subCategories),
            callback: function($$v) {
              _vm.$set(item, "subCategories", $$v)
            },
            expression: "item.subCategories"
          }
        }, _vm._l((_vm.rateCardLabels), function(label, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-2",
            attrs: {
              "value": label,
              "small": ""
            }
          }, [_vm._v(_vm._s(label))])
        }), 1)], 1)], 1)])], 1)], 1)]
      }
    }, {
      key: "item.aboutYou",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.aboutYou || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.aboutYou))
          }
        })])], 1)]
      }
    }, {
      key: "item.loadContent",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.loadContent) + "\n            " + _vm._s(item.loadContentText) + "\n          ")])]
      }
    }, {
      key: "item.giftBrand",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.giftBrand) + "\n          ")])]
      }
    }, {
      key: "item.engagement",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.engagement) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.engagement)))]) : _vm._e()])]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [(item.views) ? _c('span', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.views)))]) : _vm._e()])]
      }
    }, {
      key: "item.updatedAt",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(_vm.utils.formatCustomDate(item.updatedAt, 'DD-MM-YYYY')) + "\n          ")])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "justify-center layout px-0"
        }, [(item.star) ? _c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-2",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Unstar",
            "icon": "",
            "small": "",
            "color": "secondary",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.chgStarStatus(item, false)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', [_vm._v("mdi-star")])], 1) : _c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-2",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Star",
            "icon": "",
            "small": "",
            "color": "secondary",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.chgStarStatus(item, true)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', [_vm._v("mdi-star-outline")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "color": "secondary",
            "icon": "",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.getDataToView(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Details"
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('v-btn', {
          staticClass: "mt-2",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Delete Rate Card",
            "color": "error",
            "text": "",
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteRateCard(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "danger"
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true)
  })], 1)])], 1), _vm._v(" "), (_vm.viewData) ? _c('view-modal-dialog', {
    attrs: {
      "value": _vm.viewDialog,
      "data": _vm.viewData
    },
    model: {
      value: (_vm.viewDialog),
      callback: function($$v) {
        _vm.viewDialog = $$v
      },
      expression: "viewDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Ratecard Forms",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0b4d3f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/RateCard/DataTable.vue
// module id = 2293
// module chunks = 0